import { render, staticRenderFns } from "./host-set-auth.vue?vue&type=template&id=04de35d6&scoped=true&"
import script from "./host-set-auth.vue?vue&type=script&lang=js&"
export * from "./host-set-auth.vue?vue&type=script&lang=js&"
import style0 from "./host-set-auth.vue?vue&type=style&index=0&id=04de35d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de35d6",
  null
  
)

export default component.exports